const pushNotificationReceived = (notification) => {
  console.log('services.firebase.callbacks.pushNotificationActionPerformed called.',
    notification.actionId, notification.inputValue)
}

export default pushNotificationReceived
